import React, { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import {
    Box,
    Typography,
    List,
    ListItem,
    ListItemText,
    Grid,
    Container,
    Button
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const StockLists = () => {
    const theme = useTheme();
    const [showAllExchanges, setShowAllExchanges] = useState(false);

    const lists = [
        {
            title: 'Market Cap Groups',
            items: [
                { name: 'Mega-Cap Stocks', route: '/lists/market-cap/mega-cap?exchanges=NASDAQ%2CNYSE%2CAMEX' },
                { name: 'Large-Cap Stocks', route: '/lists/market-cap/large-cap?exchanges=NASDAQ%2CNYSE%2CAMEX' },
                { name: 'Mid-Cap Stocks', route: '/lists/market-cap/mid-cap?exchanges=NASDAQ%2CNYSE%2CAMEX' },
                { name: 'Small-Cap Stocks', route: '/lists/market-cap/small-cap?exchanges=NASDAQ%2CNYSE%2CAMEX' },
                { name: 'Micro-Cap Stocks', route: '/lists/market-cap/micro-cap?exchanges=NASDAQ%2CNYSE%2CAMEX' },
                { name: 'Nano-Cap Stocks', route: '/lists/market-cap/nano-cap?exchanges=NASDAQ%2CNYSE%2CAMEX' }
            ]
        },
        {
            title: 'Exchange Groups',
            items: [
                { name: 'NASDAQ', route: '/lists/exchange/NASDAQ' },
                { name: 'NYSE', route: '/lists/exchange/NYSE' },
                { name: 'AMEX', route: '/lists/exchange/AMEX' },
                { name: 'Amsterdam Stock Exchange', route: '/lists/exchange/AMS' },
                { name: 'Aquis Stock Exchange', route: '/lists/exchange/AQS' },
                { name: 'Athens Stock Exchange', route: '/lists/exchange/ATH' },
                { name: 'Australian Securities Exchange', route: '/lists/exchange/ASX' },
                { name: 'Berlin Stock Exchange', route: '/lists/exchange/BER' },
                { name: 'Bolsa de Madrid', route: '/lists/exchange/BME' },
                { name: 'Bombay Stock Exchange', route: '/lists/exchange/BSE' },
                { name: 'Borsa Istanbul', route: '/lists/exchange/IST' },
                { name: 'Brazil Stock Exchange', route: '/lists/exchange/SAO' },
                { name: 'Budapest Stock Exchange', route: '/lists/exchange/BUD' },
                { name: 'Buenos Aires Stock Exchange', route: '/lists/exchange/BUE' },
                { name: 'Bursa Malaysia', route: '/lists/exchange/KLS' },
                { name: 'CBOE', route: '/lists/exchange/CBOE' },
                { name: 'CBOE Europe', route: '/lists/exchange/DXE' },
                { name: 'Canadian Securities Exchange', route: '/lists/exchange/CNQ' },
                { name: 'Colombia Stock Exchange', route: '/lists/exchange/BVC' },
                { name: 'Dubai Financial Market', route: '/lists/exchange/DFM' },
                { name: 'Dusseldorf Stock Exchange', route: '/lists/exchange/DUS' },
                { name: 'Egyptian Exchange', route: '/lists/exchange/EGX' },
                { name: 'Euronext', route: '/lists/exchange/EURONEXT' },
                { name: 'Euronext Brussels', route: '/lists/exchange/BRU' },
                { name: 'Euronext Dublin', route: '/lists/exchange/DUB' },
                { name: 'Euronext Lisbon', route: '/lists/exchange/LIS' },
                { name: 'Euronext Paris', route: '/lists/exchange/PAR' },
                { name: 'Frankfurt Stock Exchange', route: '/lists/exchange/FSX' },
                { name: 'Hamburg Stock Exchange', route: '/lists/exchange/HAM' },
                { name: 'Ho Chi Minh Stock Exchange', route: '/lists/exchange/HOSE' },
                { name: 'Hong Kong Stock Exchange', route: '/lists/exchange/HKSE' },
                { name: 'Indonesia Stock Exchange', route: '/lists/exchange/JKT' },
                { name: 'International Order Book', route: '/lists/exchange/IOB' },
                { name: 'Japan Exchange Group', route: '/lists/exchange/JPX' },
                { name: 'Johannesburg Stock Exchange', route: '/lists/exchange/JNB' },
                { name: 'Korea Exchange', route: '/lists/exchange/KSC' },
                { name: 'KOSDAQ', route: '/lists/exchange/KOE' },
                { name: 'Kuwait Stock Exchange', route: '/lists/exchange/KUW' },
                { name: 'London Stock Exchange', route: '/lists/exchange/LSE' },
                { name: 'Mexican Stock Exchange', route: '/lists/exchange/MEX' },
                { name: 'Milan Stock Exchange', route: '/lists/exchange/MIL' },
                { name: 'Moscow Exchange', route: '/lists/exchange/MCX' },
                { name: 'Munich Stock Exchange', route: '/lists/exchange/MUN' },
                { name: 'NASDAQ Copenhagen', route: '/lists/exchange/CPH' },
                { name: 'NASDAQ Helsinki', route: '/lists/exchange/HEL' },
                { name: 'NASDAQ Iceland', route: '/lists/exchange/ICE' },
                { name: 'NASDAQ Riga', route: '/lists/exchange/RIS' },
                { name: 'NASDAQ Tallinn', route: '/lists/exchange/TAL' },
                { name: 'National Stock Exchange of India', route: '/lists/exchange/NSE' },
                { name: 'NEO Exchange', route: '/lists/exchange/NEO' },
                { name: 'New Zealand Exchange', route: '/lists/exchange/NZE' },
                { name: 'Oslo Stock Exchange', route: '/lists/exchange/OSL' },
                { name: 'OTC Markets', route: '/lists/exchange/OTC' },
                { name: 'OTC Markets Pink', route: '/lists/exchange/PNK' },
                { name: 'Prague Stock Exchange', route: '/lists/exchange/PRA' },
                { name: 'Qatar Stock Exchange', route: '/lists/exchange/DOH' },
                { name: 'Santiago Stock Exchange', route: '/lists/exchange/SGO' },
                { name: 'Saudi Exchange', route: '/lists/exchange/SAU' },
                { name: 'Shanghai Stock Exchange', route: '/lists/exchange/SHH' },
                { name: 'Shenzhen Stock Exchange', route: '/lists/exchange/SHZ' },
                { name: 'Singapore Stock Exchange', route: '/lists/exchange/SES' },
                { name: 'Stock Exchange of Thailand', route: '/lists/exchange/SET' },
                { name: 'Stockholm Stock Exchange', route: '/lists/exchange/STO' },
                { name: 'Stuttgart Stock Exchange', route: '/lists/exchange/STU' },
                { name: 'Swiss Exchange', route: '/lists/exchange/SIX' },
                { name: 'Taipei Exchange', route: '/lists/exchange/TWO' },
                { name: 'Taiwan Stock Exchange', route: '/lists/exchange/TAI' },
                { name: 'Tel Aviv Stock Exchange', route: '/lists/exchange/TLV' },
                { name: 'Toronto Stock Exchange', route: '/lists/exchange/TSX' },
                { name: 'Toronto Stock Exchange Ventures', route: '/lists/exchange/TSXV' },
                { name: 'Vienna Stock Exchange', route: '/lists/exchange/VIE' },
                { name: 'Warsaw Stock Exchange', route: '/lists/exchange/WSE' },
                { name: 'XETRA', route: '/lists/exchange/XETRA' },
            ],
            initialDisplay: 6
        },
        {
            title: 'Index Groups',
            items: [
                { name: 'S&P 500', route: '/lists/index/sp500' },
                { name: 'NASDAQ 100', route: '/lists/index/nasdaq' },
                { name: 'Dow Jones', route: '/lists/index/dowjones' },
            ]
        },
        {
            title: 'Sector Groups',
            items: [
                { name: 'Energy', route: '/lists/sector/energy?exchanges=NASDAQ%2CNYSE%2CAMEX' },
                { name: 'Financial Services', route: '/lists/sector/financial-services?exchanges=NASDAQ%2CNYSE%2CAMEX' },
                { name: 'Healthcare', route: '/lists/sector/healthcare?exchanges=NASDAQ%2CNYSE%2CAMEX' },
                { name: 'Industrials', route: '/lists/sector/industrials?exchanges=NASDAQ%2CNYSE%2CAMEX' },
                { name: 'Materials', route: '/lists/sector/materials?exchanges=NASDAQ%2CNYSE%2CAMEX' },
                { name: 'Consumer Staples', route: '/lists/sector/consumer-staples?exchanges=NASDAQ%2CNYSE%2CAMEX' },
                { name: 'Consumer Discretionary', route: '/lists/sector/consumer-discretionary?exchanges=NASDAQ%2CNYSE%2CAMEX' },
                { name: 'Communication Services', route: '/lists/sector/communication-services?exchanges=NASDAQ%2CNYSE%2CAMEX' },
                { name: 'Real Estate', route: '/lists/sector/real-estate?exchanges=NASDAQ%2CNYSE%2CAMEX' },
                { name: 'Technology', route: '/lists/sector/technology?exchanges=NASDAQ%2CNYSE%2CAMEX' },
                { name: 'Utilities', route: '/lists/sector/utilities?exchanges=NASDAQ%2CNYSE%2CAMEX' }
            ]
        },
        {
            title: 'Other Lists',
            //items: ['Magnificent Seven', 'Dividend Kings', 'Dividend Aristocrats', 'All REITs', 'Delisted Companies']
            items: [
                { name: 'Delisted Companies', route: '/lists/delisted' },
                { name: 'Penny Stocks', route: '/lists/penny-stocks' },
                { name: 'Crypto', route: '/lists/crypto' },
            ]
        }
    ];

    const listItemStyles = {
        borderRadius: '8px',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
            backgroundColor: theme.palette.mode === 'dark'
                ? 'rgba(255, 255, 255, 0.08)'
                : 'rgba(0, 0, 0, 0.04)',
            transform: 'translateX(4px)',
            '& .MuiListItemText-primary': {
                color: theme.palette.primary.main,
            },
        },
    };

    const linkStyles = {
        color: 'inherit',
        textDecoration: 'none',
        width: '100%',
        display: 'block',
        padding: '8px 16px',
        borderRadius: 'inherit',
        transition: 'color 0.2s ease-in-out',
    };

    const renderListItems = (items, isExchangeGroup = false) => {
        let displayedItems = items;
        if (isExchangeGroup && !showAllExchanges) {
            displayedItems = items.slice(0, 6);
        }

        // For the left column, just take the first half
        const leftColumnItems = displayedItems.slice(0, Math.ceil(displayedItems.length / 2));
        // For the right column, take the second half
        const rightColumnItems = displayedItems.slice(Math.ceil(displayedItems.length / 2));

        // Then add the "Show More" button at the end of rightColumnItems list
        if (isExchangeGroup && !showAllExchanges) {
            rightColumnItems.push({
                isButton: true,
                name: 'SHOW MORE EXCHANGES'
            });
        }

        return (
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <List dense>
                        {leftColumnItems.map((item, index) => (
                            <ListItem
                                key={index}
                                sx={listItemStyles}
                                disablePadding
                            >
                                <RouterLink
                                    to={item.route}
                                    style={linkStyles}
                                >
                                    <ListItemText
                                        primary={item.name}
                                        primaryTypographyProps={{
                                            sx: {
                                                fontSize: '1rem',
                                                transition: 'color 0.2s ease-in-out',
                                            }
                                        }}
                                    />
                                </RouterLink>
                            </ListItem>
                        ))}
                    </List>
                </Grid>
                <Grid item xs={6}>
                    <List dense>
                        {rightColumnItems.map((item, index) => (
                            item.isButton ? (
                                <Button
                                    key={index}
                                    onClick={() => setShowAllExchanges(true)}
                                    sx={{
                                        color: theme.palette.primary.main,
                                        pl: 2,
                                        mt: 1
                                    }}
                                >
                                    {item.name}
                                </Button>
                            ) : (
                                <ListItem
                                    key={index}
                                    sx={listItemStyles}
                                    disablePadding
                                >
                                    <RouterLink
                                        to={item.route}
                                        style={linkStyles}
                                    >
                                        <ListItemText
                                            primary={item.name}
                                            primaryTypographyProps={{
                                                sx: {
                                                    fontSize: '1rem',
                                                    transition: 'color 0.2s ease-in-out',
                                                }
                                            }}
                                        />
                                    </RouterLink>
                                </ListItem>
                            )
                        ))}
                    </List>
                </Grid>
            </Grid>
        );
    };

    return (
        <Box sx={{ bgcolor: theme.palette.background.default, color: theme.palette.text.primary, py: 4 }}>
            <Container maxWidth="lg">
                <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 3, fontWeight: 'bold' }}>
                    Stock Lists
                </Typography>
                {lists.map((list, index) => (
                    <Box key={index} mb={4}>
                        <Typography variant="h6" component="h2" sx={{ color: theme.palette.primary.main, mb: 2, fontWeight: 'bold' }}>
                            {list.title}
                        </Typography>
                        {renderListItems(list.items, list.title === 'Exchange Groups')}
                    </Box>
                ))}
            </Container>
        </Box>
    );
};

export default StockLists;